<script>
import Vue from "vue"
import Component from "vue-class-component"
import { mapGetters } from "vuex"

import axios from 'axios'
import uniqby from 'lodash.uniqby'
import range from "lodash.range"

import SchoolsDropdown from './SchoolsDropdown'
import { onboardingHelper } from '@/helpers/onboardingHelper'

import { Watch } from "vue-property-decorator"

import EventBus from '@/event-bus'
import store from '@/store'

import FuzzySearchbox from 'fuzzy-searchbox'

const apiBase = API_APP_PATH + "/v1"

@Component({
    components: {
        SchoolsDropdown,
        FuzzySearchbox
    },
    computed: {
        ...mapGetters({
            schools: "admin/getSchools",
            userRole: "getUserRole",
            id: "getEmployeeId"
        })
    }
})
export default class LandingPage extends Vue {
    // steps = landingPageHelper().steps

    @Watch('checkedDistricts')
    onCheckedDistrictsUpdated (val) {
        store.commit('admin/updateSelectedDistricts', val.map(x => `District ${x}`))
    }

    school = ''
    districts = []
    displayDistricts = false
    checkedDistricts = []

    get selectedSchool() {
        return this.school && typeof this.school.dbn === 'string'
    }
    get _selectedDistricts() {
        return this.selectedDistricts && this.selectedDistricts.length > 0
    }
    get allDistrictsSelected () {
        return this.checkedDistricts.length > 0 && this.checkedDistricts === this.districts
    }
    created () {
        store.commit('currentPage', 'landing')
    }
    async mounted() {        
        //TODO: update logic now that Central users are in Districts view in SQL
        if (this.userRole !== 'Central') {

            const { data: schools } = await axios.get(`${apiBase}/data/admin/app/ge/schools/${this.id}`)
            store.commit('admin/updateDistrictSchools', schools)
            const { data: districts } = await axios.get(`${apiBase}/data/admin/app/ge/districts/${this.id}`)

            store.commit('admin/updateDistrictsList', districts)
            
            this.districts = districts.map(x=> x.District).sort((a,b) => {
                return parseInt(a) - parseInt(b)
            })

            if (districts.length === 1) {
                this.checkedDistricts = [districts[0].District]
            }
        } else {
            // lodash range function creates array of all districts
            let districts = range(1, 33).map(x => x < 10 ? `0${x}` : x.toString())
            districts.push('75','79')
            store.commit('admin/updateDistrictsList', districts.map(x => ({District: x})))            
            this.districts = districts
        }
        // EventBus.$on('start intro', () => {
        //     this.startIntro()
        // })
        
        // EventBus.$on('school selected', () => {
        //     if (!localStorage.getItem('doneAdminLandingPageOnboarding')) {
        //         localStorage.setItem('doneAdminLandingPageOnboarding', true)
        //     }
        //     introJs().exit()
        // })
        
        // this.$nextTick(() => {
        //     if (localStorage.getItem('doneAdminLandingPageOnboarding') || 
        //         !this.userRole ||
        //         screen.width < 768) {
        //         return
        //     } else {
        //         this.startIntro()
        //     }
        // })
    }
    displayStringForSchool (s) {
        return `${s.dbn || s.SchoolDBN} - ${s.name || s.SchoolDBN_Name}`
    }

    moreThanOneDistrict(districts) {
        return districts.length > 1 
    }
    async goToSchoolDashboard() {
        await store.dispatch('admin/fetchSelectedSchool', {dbn: this.school.SchoolDBN})
        this.$router.push({path: 'school-dashboard'})
    }
    goToDistrictDashboard() {
        this.$router.push({path: 'district-dashboard'})
    }
    startIntro() {
        onboardingHelper().startIntro(
            introJs(), this, 'doneAdminLandingPageOnboarding'
        )
    }
    setAllDistricts () {
        this.checkedDistricts = this.allDistrictsSelected ? [] : this.districts
    }
    hideDistricts () {
        this.displayDistricts = false
    }
    uniqListOfSchools (schools) {
        return uniqby(schools, 'SchoolDBN')
    }
}
</script>

<template>
    <div class="landing-page">
        <div v-if="userRole" class="authorized">
            <div class="heading">
                <p><span>Growth Explorer</span> is a tool designed to encourage growth- and action-oriented dialogue for <i>Advance</i> eligible teachers and their administrators.</p>
            </div>
            <div class="overview">
                <div class="pulse">
                    <img src="@/assets/images/Check-pulse.png" alt="check pulse">
                    <h3>Check the Pulse</h3>
                    <p>Quickly see which schools are excelling and which might need more support.</p>
                </div>
                <div class="trends">
                    <img src="@/assets/images/analyze-trends.png" alt="analyze trends">
                    <h3>Analyze Trends</h3>
                    <p>Use data to better support schools and teachers.</p>
                </div>
                <div class="seeing-past">
                    <img src="@/assets/images/see-trends.png" alt="see trends">
                    <h3>See the Past</h3>
                    <p>Access observations and data from years past in a snapshot view.</p>
                </div>
            </div>
            <div class="actions">
                <div class="schools" v-if="userRole === 'Principal'">
                    <div class="selection">
                        <p>To get started, select a School to go see a specific schools page. Once you are there, you will see the schools dashboard and will be able to drill down to a teacher-level, as well.</p>
                    </div>
                    <div class="box">
                        <label for="schools">School</label>
                        <select v-if="schools.length > 1">
                            <option disabled value="">Select a School</option>
                        </select>
                        <p v-else>{{school.display_name}}</p>
                        <a @click="goToSchoolDashboard()">Go to Dashboard</a>
                    </div>
                </div>
                <div class="districts-schools" v-else>
                    <div>
                        <div class="selection">
                            <p>To get started, select a District or a School. Click <i>Go to Dashboard</i> if you would like to go to the District Dashboard or be directed to a School Dashboard. Once you are there you will see specific data based on the District or School you have choosen.</p>
                        </div>
                        <div class="selects">
                            <div class="box">
                                <label for="districts">{{ districts.length > 1 ? 'Districts': 'District'}}</label>
                                <div class="districts" v-if="districts.length > 1">
                                    <button 
                                        v-on:click="displayDistricts = !displayDistricts"
                                        class="dropdown-btn"
                                    >
                                        Select a District(s)
                                        <svg class="down-chevron">
                                            <line x1="0" y1="3" x2="6" y2="8" stroke="black" stroke-width="2" />
                                            <line x1="6" y1="8" x2="12" y2="3" stroke="black" stroke-width="2" />
                                        </svg>
                                    </button>
                                    <transition name="fade">
                                        <div 
                                            v-if="displayDistricts"
                                            class="dropdown"
                                        >
                                            <ul @mouseleave="hideDistricts">
                                                <li>
                                                    <input type="checkbox" id="all-districts" :checked="allDistrictsSelected" @change="setAllDistricts">
                                                    <label for="all district">All Districts</label>
                                                </li>
                                                <li 
                                                    v-for="district in districts"
                                                    :key="district"
                                                >
                                                    <input type="checkbox" :id="district" :value="district" v-model="checkedDistricts">
                                                    <label :for="district"> District {{ district }}</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </transition>
                                </div>
                                <p v-else>{{districts[0]}}</p>
                                <a @click="checkedDistricts.length > 0 && goToDistrictDashboard()">Go to Dashboard</a>
                            </div>
                            <div class="box">
                                <label for="schools">{{ schools.length > 1 ? 'Schools': 'School'}}</label>
                                <FuzzySearchbox
                                    id="select-school"
                                    v-model="school"
                                    aria-label="select a school"
                                    placeholder="Type here to select a school"
                                    :items="uniqListOfSchools(schools)"
                                    :item-keys="['SchoolDBN_Name', 'SchoolDBN']"
                                    :create-label-function="displayStringForSchool"
                                />
                                <a @click="(school !== '') && goToSchoolDashboard()">Go to Dashboard</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="unauthorized">
            <h1>LET'S CONNECT!</h1>
            <el-row>
                <el-col :xs="1" :sm="3" :md="6" :lg="6" :xl="7"></el-col>
                <el-col :xs="22" :sm="18" :md="12" :lg="12" :xl="10">
                    <p>Hi there! It seems that your school and/or district is not using Growth Explorer, just yet.</p>
                    <p>However, we would still love to chat with you about your interest in Growth Explorer.</p>
                    <p><a href="mailto:growthexplorer@schools.nyc.gov">Email us</a> to set up a time that works best for you.</p>
                    <p>
                        Look forward to connecting!
                        <br>
                        - The Team at Growth Explorer
                    </p>
                </el-col>
                <el-col :xs="1" :sm="3" :md="6" :lg="6" :xl="7"></el-col>
            </el-row>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.landing-page {
    max-width: 676px;
    margin: 0 auto;
    .authorized {
        .heading {
            margin-bottom: 3.3em;
            p {
                font-family: 'Arial';
                font-size: 1.5em;
                color: #000000;
                line-height: 30px;
            }
            span {
                font-weight: bold;
            }
        }
        .overview {
            display: flex;
            justify-content: space-between;
            font-family: 'Arial';
            text-align: center;
            margin-bottom: 4em;
            .pulse, .trends, .seeing-past {
                color: #ffffff;
                padding: 10px;
            }
            .pulse {
                background-color: #5d4761;
            }
            .trends {
                background-color: #ae6401;
            }
            .seeing-past {
                background-color: #257d8c;
            }
            h3 {
                font-size: 1em;
            }
            p {
                font-size: .7em;
                color: #ffffff;
            }
        }
        .overview > div {
            width: 147px;
            height: 183px;
            img {
                padding-top: 20px;
            }
        }
        .selection {
            p {
                font-family: 'Arial';
                font-size: 1em;
                line-height: 25px;
            }
        }
        .actions {
            .schools {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .schools > div {
                width: 318px;
            }
            .districts-schools {
                .selects {
                    display: flex;
                    justify-content: space-between;
                }
            }
        }
        .box {
            width: 318px;
            box-sizing: border-box;
            padding: 33px;
            border: 1px solid #000000;

            label {
                padding: 0 5px;
                width: 114px;
                height: 21px;
                display: flex;
                align-items: center;
                font-family: 'Arial';
                font-size: .75em;
                font-weight: 700;
                border-right: 1px solid #000000;
                border-top: 1px solid #000000;
                border-left: 1px solid #000000;
            }
            button {
                width: 250px;
                background-color: transparent;
                border: 1px solid #000000;
                margin-bottom: 4em;
                padding: 1px 5px 1px 5px;
                height: 30px;
                text-align: left;
            }
            button, a {
                font-family: Arial;
                font-size: 12px;
                cursor: pointer;
            }
            a {
                display: block;
                padding: .75em;
                width: 114px;
                border: none;
                outline: none;
                background-color: #2c557d;
                color: #ffffff;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
            }
            p {
                padding: 0 2px;
                margin: 0 0 3em 0;
                border: 1px solid #000000;
                height: 30px;
                font-size: .75em;
                color: #4a4a4a;
                display: flex;
                align-items: center;
            }
            select {
                border: 1px solid #000000;
                width: 100%;
                height: 30px;
                margin-bottom: 3em;
            }
            #select-school {
                width: 250px;
                height: 30px;
                margin-bottom: 3em;
                ::v-deep input {
                    border: none;
                    display: flex;
                    border: 1px solid #000000;
                    font-family: Arial;
                    align-items: center;
                    padding-left: 5px;
                    height: 28px;
                }
                ::v-deep #autocomplete-results {
                    font-family: Arial;
                }
                ::v-deep .autocomplete-results {
                    li {
                        font-size: 14px;
                    }
                    .is-active {
                        background-color: #769D4E;
                    }
                }
            }
            .districts {
                position: relative;
            }
        }
        .dropdown {
            position: absolute;
            top: 35px;
            z-index: 10;
            ul {
                position: absolute;
                width: 200px;
                max-height: 200px;
                overflow: scroll;
                overflow-x: hidden;
                list-style-type: none;
                padding: 5px;
                margin: 5px 0 0 0;
                border: 1px solid #979797;
                background-color: #fff;
                border-radius: 3px;
            }
            li {
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                font-size: .875em;
            }
            li label {
                margin: 0;
                border: none;
                font-weight: normal;
                font-size: 1em;
            }
        } 
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .dropdown-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .down-chevron {
        width: 12px;
        height: 12px;
    }
    .unauthorized {
        h1 {
            font-size: 3em;
            color: #613f75;
        }
        div {
            padding: 0.1em;
            div:nth-of-type(2) {
                background-color: #e7dbee;
                border: 1px solid #979797;
                border-radius: 0.5em;
                p {
                    text-align: left;
                    font-family: 'museo_sans', sans-serif;
                    font-size: 1.4em;
                    padding: 0 1.25em;
                    color: #000000;
                }
            }
        }
    }
}
</style>
